export const baseUrl = window.location.origin;

export const getUrlParam = (param: string): string => {
	const params = new URLSearchParams(window.location.search);
	return params.get(param) ?? '';
};
